import React, {useContext} from "react";
import MsmContext from "../../reducers/Context";
import Icon from "../Icon";
import "./styles.css";

export default props => {
    const {dispatch} = useContext(MsmContext);

    const handleButtonClick = e => {
        if (props.actionType) {
            dispatch({
                type: props.actionType,
                payload: props.payload
            });
        } else if (props.onClick) {
            props.onClick(e);
        }
    };

    const textPropClassName = props.text ? `${props.text.replace(/\s/gi, '-').toLowerCase()}-button` : '';
    return (
        <button
            onClick={handleButtonClick}
            type={props.type || 'button'}
            className={`afs-msm-nav-button ${textPropClassName} ${props.className || ''}`}
            style={{backgroundColor: props.colour}}
        >
            {props.icon && (
                <Icon
                    className="afs-msm-nav-button-icon"
                    icon={props.icon}
                    iconSize={props.iconSize}
                    iconFill={props.iconFill}
                    iconStroke={props.iconStroke}
                />
            )}
            {props.text && (
                <div className="afs-msm-nav-button-text">{props.text}</div>
            )}
        </button>
    );
};
